import { types } from 'mobx-state-tree';

import { DATAPOINT_FIELD_KEYS, DATAPOINT_SOURCES, DATAPOINT_STATUS } from './consts';

const model = {
  fieldKey: types.enumeration('DATAPOINT_FIELD_KEYS', Object.values(DATAPOINT_FIELD_KEYS)),
  source: types.enumeration('DATAPOINT_SOURCES', Object.values(DATAPOINT_SOURCES)),
  status: types.enumeration('DATAPOINT_STATUS', Object.values(DATAPOINT_STATUS)),
  oldValue: types.maybeNull(types.string),
  newValue: types.maybeNull(types.string),
};

const actions = () => ({});
const views = () => ({});

const ContactChangeModel = types
  .model(model)
  .actions(actions)
  .views(views);

export default ContactChangeModel;
